import React from 'react'

import {
  Box,
  Color,
  Divider,
  Paragraph,
  Text,
  Display,
  Heading2,
  Space,
  FontSize,
  FontWeight,
  AlignItems,
  JustifyContent,
  Image,
} from '@gousto-internal/citrus-react'
import { useSelector } from 'react-redux'

import { NumPersonsToBoxDescriptors } from 'routes/BoxPrices/boxPricesModels'
import {
  getNumPersonsToBoxDescriptors,
  getMenuBoxPricesRecieve,
} from 'routes/BoxPrices/boxPricesSelectors'
import { signupConfig } from 'routes/Signup/signupConfig'

import twoPortionsPng from '../../../../media/images/box-prices/2-portions.png'
import twoPortionsWebp from '../../../../media/images/box-prices/2-portions.webp'
import fourPortionsPng from '../../../../media/images/box-prices/4-portions.png'
import fourPortionsWebp from '../../../../media/images/box-prices/4-portions.webp'

type BoxSizePriceBreakdownInfoProps = {
  heading: string
  subHeading: string
  boxSize: number
}

export const BoxSizePriceBreakdownInfo = ({
  heading,
  subHeading,
  boxSize,
}: BoxSizePriceBreakdownInfoProps) => {
  const numPersonsToBoxDescriptors = useSelector(
    getNumPersonsToBoxDescriptors,
  ) as NumPersonsToBoxDescriptors

  const boxPrices = numPersonsToBoxDescriptors[boxSize]

  const isPriceDataLoading = Boolean(useSelector(getMenuBoxPricesRecieve))

  const headerImageWebp = boxSize === 2 ? twoPortionsWebp : fourPortionsWebp
  const headerImagePng = boxSize === 2 ? twoPortionsPng : fourPortionsPng
  const boxSizeType = boxSize === 2 ? 'regular' : 'large'
  const { boxInfoTextStart, boxInfoTextEnd } = signupConfig.boxSizePriceBreakdownStep
  const { pricePlaceholder } = signupConfig.boxSizePriceBreakdownStep

  const { promo_code_valid: isPromoCodeValid, total, totalAfterDiscount } = boxPrices[0]
  const minimumBoxPrice = isPromoCodeValid ? totalAfterDiscount : total

  return (
    <Box paddingH={6} paddingRight={5}>
      <Box
        display={Display.Flex}
        height="1.6rem"
        alignItems={AlignItems.FlexEnd}
        justifyContent={JustifyContent.SpaceBetween}
      >
        <Heading2 size={4} color={Color.ColdGrey_900}>
          {heading}
        </Heading2>
        <Image
          srcSet={`${headerImageWebp}, ${headerImagePng}`}
          height="68px"
          width="auto"
          minWidth={boxSizeType === 'regular' ? '110px' : '165px'}
          src={headerImagePng}
          alt=""
        />
      </Box>
      <Space size={2} direction="vertical" />
      <Paragraph size={2}>{subHeading}</Paragraph>
      <Space size={3} direction="vertical" />
      <Divider />
      <Space size={3} direction="vertical" />
      <Text
        size={0 as FontSize}
        display={Display.InlineBlock}
        color={Color.ColdGrey_900}
        fontWeight={FontWeight.SemiBold}
      >
        {boxInfoTextStart}{' '}
        <Text display={Display.InlineBlock} size={3} fontWeight={FontWeight.SemiBold}>
          {isPriceDataLoading || !minimumBoxPrice ? pricePlaceholder : `£${minimumBoxPrice}`}{' '}
        </Text>{' '}
        {boxInfoTextEnd}
      </Text>
      <Text size={0 as FontSize} color={Color.ColdGrey_600}>
        {isPromoCodeValid ? `Was £${total} ${boxInfoTextEnd}` : ''}
      </Text>
      <Space size={2} direction="vertical" />
    </Box>
  )
}
